
export class ValidateRules {

  public static searchTermCsv = {
    validate: (value: string) => /^\s*[a-z0-9_-]{2,20}(\s*,\s*[a-z0-9_-]{2,20})*\s*$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid CSV list of search terms including letters, numbers, underscores (_), dashes (-)'
  };

  public static validNewEntepriseId = {
    validate: (value: string) => /^[a-z0-9-]{2,}(\.[a-z0-9-]{2,})*$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid enterprise id including letters, numbers and dashes (-)'
  };

  public static possibleEnterpriseId = {
    validate: (value: string, args: { curEntIdList: string[] }) => {
      const curEntIdList = args.curEntIdList;

      // we verify that the enterpriseId is not in used already AND that there is a possible parent in the hierarchy
      return !curEntIdList.includes(`` + value) && curEntIdList.some(entId => (`` + value).startsWith(`${entId}.`));
    },
    params: ['curEntIdList'],
    message:'Enterprise {_value_} has no possible parent in the hierarchy'
  };

  public static validSubscriberId = {
    validate: (value: string) => /^[1-9][0-9]{9}$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid actility subscriber id - 10 digits number'
  };

  public static validSupplierId = {
    validate: (value: string) => /^[a-z0-9-_]{3,}$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid actility supplier id including letters, numbers, dashes (-) and underscores (_)'
  };

  public static url = {
    validate: (value: string) => {

      // source https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url

      const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(value);
      
    },
    params: [],
    message:'The {_field_} field must be a valid URL'
  };

  public static validEnrolId = {
    validate: (value: string) => /^[a-z0-9-]{3,}$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid enrol identifier including letters, numbers, dashes (-)'
  };

  public static nonRepeatedId = {
    validate: (value: string, args: { curIdList: string[] }) => {
      const curIdList = args.curIdList;

      // we verify that the id is not in use
      return !curIdList.includes(`` + value);
    },
    params: ['curIdList'],
    message:'Id {_value_} is already in use'
  };

  //
}
